import React from "react";
import { css } from "emotion";
import datetime from "dayjs"; 
import startCase from 'lodash/startCase';

import StateContext from "../contexts/State";
import If from "./If";
import Checkmark from "./Checkmark";
import lookupProvince from "../constants/Provinces";

const widgetStyle = (hidden, config = { bottom: 0 }) =>
  css({
    display: "flex",
    alignItems: "center",
    position: "fixed",
    zIndex: 1000000,
    bottom: hidden ? -100 : config.bottom,
    left: 0,
    margin: 15,
    padding: "15px 50px",
    boxShadow: "0px 7px 15px 1px rgba(0,0,0,.33)",
    background: "#ffffff",
    borderRadius: 500,
    opacity: hidden ? 0 : 1,
    transition: "bottom 666ms ease, opacity 666ms ease",
    "@media (max-width: 768px)": {
      marginBottom: 75
    }
  });

const contentStyle = css({
  fontFamily: "sans-serif"
});

const customerStyle = css({
  fontWeight: "bold",
  fontSize: "1.1rem",
  lineHeight: "1.3rem"
});

const actionStyle = css({
  fontSize: "0.9rem",
  lineHeight: "1.1rem"
});

const whenStyle = css({
  fontSize: "0.8rem",
  lineHeight: "1.0rem",
  opacity: 0.66
});

const Widget = ({ selectors }) => (
  <React.Fragment>
    <If test={selectors.hasData()}>
      {() => (
        <div
          className={widgetStyle(
            selectors.isWidgetVisible(),
            window.SOCIAL_PROOF_CONFIG
          )}
        >
          <Checkmark animate={selectors.shouldAnimateCheckmark()} />

          <div className={contentStyle}>
            <div className={customerStyle}>
              {startCase(selectors.getCurrentOrder().customer)}
              {" from "}
              {lookupProvince(selectors.getCurrentOrder().province)}
            </div>
            <div className={actionStyle}>
              Recently bought <em>{selectors.getCurrentOrder().product}</em>
            </div>
            <If test={selectors.isCurrentOrderRecent()}>
              <div className={whenStyle}>
                {datetime(selectors.getCurrentOrder().when).fromNow()}
              </div>
            </If>
          </div>
        </div>
      )}
    </If>
  </React.Fragment>
);

const WidgetContainer = () => (
  <StateContext.Consumer>
    {({ selectors }) => <Widget selectors={selectors} />}
  </StateContext.Consumer>
);

export default WidgetContainer;
